import CustomMenuItem from "./CustomMenuItem";
import { Box, Button, Drawer, Grid, Toolbar, Typography } from "@mui/material";
import Divider from "@mui/material/Divider";
import { styled } from "@mui/material/styles";
import LogoutIcon from "@mui/icons-material/Logout";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import React, { useState, useEffect, useContext } from "react";
import { useIntl } from "react-intl";
import { useSelector, useDispatch } from "react-redux";
import { AuthContext } from "../utils/authProvider";
import { setCompany } from "../redux/commonSlice";
import { setActAs } from "../redux/actasSlice";
import { signoutRedirect } from "../services/userService";
import axios from "../api/axiosClient";
import { errorToast, handleError } from "../services/serviceBase";

export default function Sidebar(props) {
  const [open, setOpen] = useState(true);

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };

  const intl = useIntl();
  const dispatch = useDispatch();
  const userManager = useContext(AuthContext);
  const user = useSelector((state) => state.auth.user);

  const handleLogout = () => {
    dispatch(setCompany(0));
    dispatch(setActAs({ customerCode: null }));
    signoutRedirect(userManager);
  };

  const [allMenuItems, setAllMenuItems] = useState([]);
  const [minContentHeigth, setMinContentHeigth] = useState(550);

  const DrawerHeader = styled("div")(({ theme }) => ({
    display: "flex",
    padding: theme.spacing(0, 1),
  }));

  const DrawerContent = styled("div")(({ theme }) => ({
    overflowY: "auto",
    minHeight: `${minContentHeigth}px`,
    padding: theme.spacing(0, 1),
  }));

  const DrawerFooter = styled("div")(({ theme }) => ({
    width: props.drawerWidth - 1,
    zIndex: theme.zIndex.drawer + 1,
    display: "flex",
    ...theme.mixins.toolbar,
  }));

  const drawerContent = React.useMemo(
    () => (
      <DrawerContent id="DrawerContent">
        {allMenuItems == undefined && allMenuItems == 0 ? (
          <div>Loading...</div>
        ) : (
          allMenuItems.map((x) => (
            <CustomMenuItem
              Name={x.Name}
              key={x.Id}
              Id={x.Id}
              Company={x.Company}
              Children={x.Children}
              IsVisibleEntry={x.IsVisibleEntry}
              Root={x.Root}
              Link={x.Link}
            />
          ))
        )}
      </DrawerContent>
    ),
    [allMenuItems]
  );

  useEffect(() => {
    axios
      .get("/menu")
      .then((response) => {
        const menuItems = generateManuItems(response.data);
        setAllMenuItems(menuItems);
      })
      .catch((error) => {
        handleError(error, intl);
      });
  }, []);

  function generateManuItems(menuItems, depth = 0) {
    let newMenuItems = [];
    menuItems.forEach((menuItem) => {
      const newMenuItem = {
        Id: menuItem.id,
        Name: menuItem.name,
        Link: menuItem.link,
        Company: menuItem.company,
        IsVisibleEntry: menuItem.isVisible,
        Root: menuItem.root,
      };

      if (menuItem.children && menuItem.children.length > 0) {
        let children = generateManuItems(menuItem.children, depth + 1); // Recursively print children
        newMenuItem.Children = children;
      } else if (depth >= 2) {
        newMenuItem.Class = "apeBlueColorTextItalic";
      }

      newMenuItems.push(newMenuItem);
    });
    return newMenuItems;
  }

  return (
    <div>
      <Drawer
        open={props.open}
        onClose={toggleDrawer(!props.open)}
        variant="persistent"
        sx={{
          width: 300,
          flexShrink: 0,
          [`& .MuiDrawer-paper`]: {
            width: 300,
            boxSizing: "border-box",
            backgroundColor: "#D8D8D8",
            overflowX: "hidden",
            overflowY: "hidden",
          },
        }}
      >
        <Toolbar />

        <DrawerHeader
          sx={{ background: "#9C9B9B", color: "white" }}
          id="DrawerHeader"
        >
          <Box sx={{ p: 1, margin: "auto", flexGrow: 1 }}>
            <Grid container spacing={2}>
              <Grid item>
                <AccountCircleIcon fontSize="large" />
              </Grid>
              <Grid item xs sx={{ mt: 0.5 }}>
                <Typography gutterBottom variant="subtitle1" component="div">
                  {user != null && user.profile != null
                    ? user.profile.name
                    : ""}
                </Typography>
              </Grid>
            </Grid>
          </Box>
        </DrawerHeader>

        <Box sx={{ p: 1 }} textAlign="left" id="logout">
          <Button
            sx={{ p: 2 }}
            variant="text"
            color="inherit"
            startIcon={<LogoutIcon />}
            className="apeBlueColor"
            fontSize="large"
            onClick={handleLogout}
          >
            Logout
          </Button>
          <Divider />
        </Box>

        {drawerContent}
        <Divider />

        <DrawerFooter id="DrawerFooter">
          <Grid container spacing={2}>
            <Grid item xs={12} sm container>
              <Grid item xs container direction="column" spacing={2}>
                <Grid item xs>
                  <Typography
                    textAlign={"center"}
                    gutterBottom
                    variant="subtitle1"
                    component="div"
                  >
                    Powered by Remira Italia
                  </Typography>
                  <Typography textAlign={"center"} gutterBottom variant="body2">
                    v.1.1
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </DrawerFooter>
      </Drawer>
    </div>
  );
}
